import { ReactNode } from "react";
import { Box } from "~/components/Box";
import { Card } from "~/components/Card";
import { Flex } from "~/components/Flex";
import { SearchBar } from "~/components/Input/SearchBar";
import { Pagination } from "~/components/Pagination/Pagination";
import { H5 } from "~/components/Typography";

export interface PaginatedTableCardProps {
  title: string;
  search?: string;
  onSearchChange?: (search: string) => void;
  searchPlaceholder?: string;
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  children: ReactNode;
  hasData?: boolean;
}

export const PaginatedTableCard = ({
  title,
  search,
  onSearchChange,
  searchPlaceholder,
  page,
  totalPages,
  onPageChange,
  children,
  hasData = true,
}: PaginatedTableCardProps) => {
  return (
    <Card>
      <Flex direction="column" gap="4" css={{ p: "$6", pb: "$4" }}>
        <H5 css={{ fw: "600" }}>{title}</H5>
        {searchPlaceholder && onSearchChange && search !== undefined && (
          <Box css={{ maxWidth: "320px" }}>
            <SearchBar
              search={search}
              onSearchChange={onSearchChange}
              placeholder={searchPlaceholder}
            />
          </Box>
        )}
      </Flex>

      {children}

      {hasData && totalPages > 1 && (
        <Flex justify="end" css={{ p: "$6" }}>
          <Pagination
            activePage={page}
            pagesCount={totalPages}
            setActivePage={onPageChange}
          />
        </Flex>
      )}
    </Card>
  );
};
